// extracted by mini-css-extract-plugin
module.exports = {"volumeMeter":"VolumeMeter_volumeMeter__2SZIE"};